class WbUgcVideos {
  constructor() {
    this.modal = document.querySelector('[data-wbugc-modal]');
    this.videoTarget = document.querySelector('[data-wbugc-video-target]');
    this.titleTarget = document.querySelector('[data-wbugc-title-target]');
    this.textTarget = document.querySelector('[data-wbugc-text-target]');
    this.triggers = document.querySelectorAll('[data-wbugc-trigger]');
    this.closeBtn = document.querySelectorAll('[data-wbugc-close]');

    if (!this.modal) return;
    this.init();
  }

  init() {
    this.triggers.forEach(t => {
      t.addEventListener('click', (e) => {
        const item = e.target.closest('[data-wbugc-item]');
        const data = JSON.parse(item.querySelector('template').innerHTML);
        this.open(data);
      });
    });

    this.closeBtn.forEach(b => b.addEventListener('click', () => this.modal.close()));
    this.modal.addEventListener('close', () => this.videoTarget.innerHTML = '');
  }

  open(data) {
    if (!data.videoHtml) return;
    this.videoTarget.innerHTML = data.videoHtml;
    this.titleTarget.textContent = data.title || '';
    this.textTarget.innerHTML = data.text || '';
    this.modal.showModal();
  }
}

document.addEventListener('DOMContentLoaded', () => new WbUgcVideos());